export default "__VITE_ASSET__CldaujaW__"